module.exports = __webpack_public_path__ + "static/67gde-c63f2acf947b0874477772fc938b8ce4.gif";